import React from "react";
import * as PropTypes from "prop-types";
import { Box } from "@chakra-ui/core";
import { remark } from "remark";
import remark2react from "remark-react";
import parse from "remark-parse";
import { SubHeading } from "../headings";
import Paragraph from "./paragraph";
import Separator from "./separator";
import UnorderedList from "./unorderedList";
import OrderedList from "./orderedList";
import AltSubHeading from "./altSubHeading";
import AltMainHeading from "./altMainHeading";
import BlockQuote from "./blockQuote";
import MdLink from "./mdLink";
import "./md.css";

const components = {
  h1: SubHeading,
  h2: SubHeading,
  h3: SubHeading,
  h4: SubHeading,
  p: Paragraph,
  hr: Separator,
  ul: UnorderedList,
  ol: OrderedList,
  blockquote: BlockQuote,
};

const altComponents = {
  ...components,
  h1: AltMainHeading,
  h2: AltSubHeading,
  a: MdLink,
}

const getReactFromMD = (md, alt) => remark()
  .use(parse)
  .use(
    remark2react,
    {
      createElement: React.createElement,
      remarkReactComponents: alt ? altComponents : components,
    }
  ).processSync(md);

const MarkDown = ({ md, alt, ...rest }) => {
  const data = getReactFromMD(md, alt);
  return (
    <Box
      className="md-content"
      {...rest}
    >
      {data.result}
    </Box>
  );
}

MarkDown.propTypes = {
  md: PropTypes.string.isRequired,
  alt: PropTypes.bool,
};

MarkDown.defaultProps = {
  alt: false,
};

export default MarkDown;
